module.exports = __webpack_public_path__ + "img/bretta-intro.7f85d932.png";